var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessengerInvoice = function SvgMessengerInvoice(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75008 6.70801C4.75008 6.17874 5.17914 5.74967 5.70842 5.74967H11.4584C11.9877 5.74967 12.4167 6.17874 12.4167 6.70801C12.4167 7.23728 11.9877 7.66634 11.4584 7.66634H5.70842C5.17914 7.66634 4.75008 7.23728 4.75008 6.70801Z",
    fill: "#082344"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70842 10.0622C5.17914 10.0622 4.75008 10.4912 4.75008 11.0205C4.75008 11.5498 5.17914 11.9788 5.70842 11.9788H11.4584C11.9877 11.9788 12.4167 11.5498 12.4167 11.0205C12.4167 10.4912 11.9877 10.0622 11.4584 10.0622H5.70842Z",
    fill: "#082344"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75008 15.333C4.75008 14.8037 5.17914 14.3747 5.70842 14.3747H11.4584C11.9877 14.3747 12.4167 14.8037 12.4167 15.333C12.4167 15.8623 11.9877 16.2913 11.4584 16.2913H5.70842C5.17914 16.2913 4.75008 15.8623 4.75008 15.333Z",
    fill: "#082344"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 7.66634C15.821 7.66634 16.2501 7.23728 16.2501 6.70801C16.2501 6.17874 15.821 5.74967 15.2917 5.74967H15.287C14.7577 5.74967 14.3286 6.17874 14.3286 6.70801C14.3286 7.23728 14.7577 7.66634 15.287 7.66634H15.2917Z",
    fill: "#082344"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 11.0205C16.2501 11.5498 15.821 11.9788 15.2917 11.9788H15.287C14.7577 11.9788 14.3286 11.5498 14.3286 11.0205C14.3286 10.4912 14.7577 10.0622 15.287 10.0622H15.2917C15.821 10.0622 16.2501 10.4912 16.2501 11.0205Z",
    fill: "#082344"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 16.2913C15.821 16.2913 16.2501 15.8623 16.2501 15.333C16.2501 14.8037 15.821 14.3747 15.2917 14.3747H15.287C14.7577 14.3747 14.3286 14.8037 14.3286 15.333C14.3286 15.8623 14.7577 16.2913 15.287 16.2913H15.2917Z",
    fill: "#082344"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916748 3.35384C0.916748 2.03066 1.9894 0.958008 3.31258 0.958008H17.6876C19.0108 0.958008 20.0834 2.03066 20.0834 3.35384V19.6455C20.0834 20.9687 19.0108 22.0413 17.6876 22.0413H3.31258C1.9894 22.0413 0.916748 20.9687 0.916748 19.6455V3.35384ZM3.31258 2.87467C3.04794 2.87467 2.83341 3.0892 2.83341 3.35384V19.6455C2.83341 19.9101 3.04794 20.1247 3.31258 20.1247H17.6876C17.9522 20.1247 18.1667 19.9101 18.1667 19.6455V3.35384C18.1667 3.0892 17.9522 2.87467 17.6876 2.87467H3.31258Z",
    fill: "#082344"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessengerInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messenger-invoice.4ebcb5af.svg";
export { ForwardRef as ReactComponent };